import React from "react";

import makeStyles from "@mui/styles/makeStyles";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import Grid from "@mui/material/Grid";
import { map } from "ramda";
import { Box } from "@mui/material";
import { notBlank } from "../util/ext";
import { grey } from "@mui/material/colors";

const useStyles = makeStyles(theme => ({
  itemContent: {
    height: "auto",
    fontSize: "1.4rem",
    borderBottom: "solid",
    borderBottomColor: grey[200],
  },

  listItemText: {
    textTransform: "none",
  },

  contentTitle: {
    fontSize: "1.8rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
  },

  mainDetail: {
    fontSize: "1.4rem",
    display: "flex",
    justifyContent: "flex-start",

    "& label": {
      fontWeight: "bold",
      paddingRight: "0.5em",
    },
  },
}));

const RipEndpointListItem = ({ endpoint, selected, findModule }) => {
  const classes = useStyles();

  return (
    <ListItem
      selected={selected}
      classes={{ root: classes.itemContent }}
      key={endpoint.ripEndpointId}
    >
      <ListItemText
        classes={{ root: classes.listItemText }}
        disableTypography={true}
        primary={
          <React.Fragment>
            <div className={classes.contentTitle}>
              {endpoint.ripEndpointName}
            </div>
          </React.Fragment>
        }
        secondary={
          <React.Fragment>
            <Grid container justifyContent="space-between" spacing={5}>
              <Grid item sm={6}>
                <div className={classes.mainDetail}>
                  <label>RIP Endpoint Id:</label>
                  {endpoint.ripEndpointId}
                </div>
              </Grid>

              <Grid item sm={6}>
                <div className={classes.mainDetail}>
                  <label>Upload Path:</label>
                  {endpoint.ripEndpoint}
                </div>
              </Grid>

              {notBlank(endpoint.defaultModules) && (
                <Grid item sm={6}>
                  <div className={classes.mainDetail}>
                    <label>Default Modules:</label>
                    <Box>
                      {map(
                        module => (
                          <Box key={module}>{findModule(module)}</Box>
                        ),
                        endpoint.defaultModules,
                      )}
                    </Box>
                  </div>
                </Grid>
              )}
            </Grid>
          </React.Fragment>
        }
      />
    </ListItem>
  );
};

export default RipEndpointListItem;
